/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropInstagramPostResponse
 */
export interface DropInstagramPostResponse {
    /**
     * 
     * @type {string}
     * @memberof DropInstagramPostResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DropInstagramPostResponse
     */
    shortcode: string;
    /**
     * 
     * @type {string}
     * @memberof DropInstagramPostResponse
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof DropInstagramPostResponse
     */
    embedUrl: string;
    /**
     * 
     * @type {string}
     * @memberof DropInstagramPostResponse
     */
    displayUrl: string;
    /**
     * 
     * @type {string}
     * @memberof DropInstagramPostResponse
     */
    thumbnailUrl: string;
    /**
     * 
     * @type {number}
     * @memberof DropInstagramPostResponse
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof DropInstagramPostResponse
     */
    height: number;
    /**
     * 
     * @type {boolean}
     * @memberof DropInstagramPostResponse
     */
    isVideo: boolean;
    /**
     * 
     * @type {string}
     * @memberof DropInstagramPostResponse
     */
    videoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DropInstagramPostResponse
     */
    caption: string;
    /**
     * 
     * @type {number}
     * @memberof DropInstagramPostResponse
     */
    likeCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DropInstagramPostResponse
     */
    commentCount?: number;
    /**
     * 
     * @type {string}
     * @memberof DropInstagramPostResponse
     */
    coverImageProxyUrl?: string | null;
}

/**
 * Check if a given object implements the DropInstagramPostResponse interface.
 */
export function instanceOfDropInstagramPostResponse(value: object): value is DropInstagramPostResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('shortcode' in value) || value['shortcode'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('embedUrl' in value) || value['embedUrl'] === undefined) return false;
    if (!('displayUrl' in value) || value['displayUrl'] === undefined) return false;
    if (!('thumbnailUrl' in value) || value['thumbnailUrl'] === undefined) return false;
    if (!('width' in value) || value['width'] === undefined) return false;
    if (!('height' in value) || value['height'] === undefined) return false;
    if (!('isVideo' in value) || value['isVideo'] === undefined) return false;
    if (!('caption' in value) || value['caption'] === undefined) return false;
    return true;
}

export function DropInstagramPostResponseFromJSON(json: any): DropInstagramPostResponse {
    return DropInstagramPostResponseFromJSONTyped(json, false);
}

export function DropInstagramPostResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropInstagramPostResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'shortcode': json['shortcode'],
        'url': json['url'],
        'embedUrl': json['embedUrl'],
        'displayUrl': json['displayUrl'],
        'thumbnailUrl': json['thumbnailUrl'],
        'width': json['width'],
        'height': json['height'],
        'isVideo': json['isVideo'],
        'videoUrl': json['videoUrl'] == null ? undefined : json['videoUrl'],
        'caption': json['caption'],
        'likeCount': json['likeCount'] == null ? undefined : json['likeCount'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'coverImageProxyUrl': json['coverImageProxyUrl'] == null ? undefined : json['coverImageProxyUrl'],
    };
}

export function DropInstagramPostResponseToJSON(json: any): DropInstagramPostResponse {
    return DropInstagramPostResponseToJSONTyped(json, false);
}

export function DropInstagramPostResponseToJSONTyped(value?: DropInstagramPostResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'shortcode': value['shortcode'],
        'url': value['url'],
        'embedUrl': value['embedUrl'],
        'displayUrl': value['displayUrl'],
        'thumbnailUrl': value['thumbnailUrl'],
        'width': value['width'],
        'height': value['height'],
        'isVideo': value['isVideo'],
        'videoUrl': value['videoUrl'],
        'caption': value['caption'],
        'likeCount': value['likeCount'],
        'commentCount': value['commentCount'],
        'coverImageProxyUrl': value['coverImageProxyUrl'],
    };
}

